module.exports = __webpack_public_path__ + "static/media/reshetkaR.cccfe9f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/specialApplications/reshetkaR.jpg
// module id = 221
// module chunks = 0